import script from "./apikeyplatformInstitutions.vue?vue&type=script&setup=true&lang=js"
export * from "./apikeyplatformInstitutions.vue?vue&type=script&setup=true&lang=js"

import "./apikeyplatformInstitutions.vue?vue&type=style&index=0&id=d4f7ed38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4f7ed38"]])

export default __exports__